<template>
  <action-meal-remove
  :state="state"
  :showText="showText"
  :limitText="limitText"
  v-on="$listeners"
  @clicked="clicked()"></action-meal-remove>
</template>

<script>
import ActionMealRemove from '../../../global/actions/ActionMealRemove.vue'

export default {
  name: 'CardMealActionRemove',
  components: {
    ActionMealRemove
  },
  props:
    {
      state: {
        type: String,
        default: ''
      },
      showText: {
        type: Boolean,
        default: true
      },
      limitText: {
        type: Boolean,
        default: false

      }
    },
  computed: {
    componentClasses: function () {
      return {
        'gc-card-meal__action': true,
        'gc-card-meal__action-remove': true,
        'gc-card-meal__action-disabled': this.state === 'disabled',
        'gc-card-meal__action-onTap': this.state === 'onTap',
        'gc-card-meal__action-active': this.state === 'active'
      }
    },
    text: function () {
      let text = this.$i18n.t('message["meal-plan.remove"]')
      if (this.state === 'active') {
        return this.$i18n.t('message["meal-plan.removing"]')
      }
      if (this.limitText) {
        text = text.substring(0, 2) + '...'
      }
      return text
    }
  },
  methods: {
    clicked () {
      this.$emit('clicked')
    }
  }
}
</script>
<style scoped>
</style>
